export enum DocumentType {
  PASSPORT = 'PASSPORT',
  WORKPASS = 'WORKPASS',
  NRICFIN = 'NRICFIN',
}
